import { Link } from "react-router-dom";

/** The closing spruce CTA band — reused across the home hub and every deep page
 *  so the conversion moment is consistent. Copy is overridable per page. */
export function CtaBand({
  eyebrow = "Private beta",
  title = "Bring your floor plan. Watch it become a stamped design.",
  sub = "Book a demo and run a real plan live, or join the beta waitlist. Either way, the stamp stays with your PE.",
}: {
  eyebrow?: string;
  title?: string;
  sub?: string;
}) {
  return (
    <section className="landing-wrap" id="get-started">
      <div className="cta-band">
        <svg className="cta-band-bg" viewBox="0 0 1080 240" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
          <defs>
            <pattern id="fm-chev" width="38" height="32" patternUnits="userSpaceOnUse">
              <path d="M7 19 L19 11 L31 19" fill="none" stroke="#FFFFFF" strokeWidth="1.6" opacity="0.13" strokeLinecap="round" strokeLinejoin="round" />
            </pattern>
          </defs>
          <rect width="1080" height="240" fill="url(#fm-chev)" />
        </svg>

        <div className="cta-band-inner">
          <span className="section-eyebrow">{eyebrow}</span>
          <h2 className="section-title">{title}</h2>
          <p className="cta-sub">{sub}</p>
          <div className="cta-band-actions">
            <Link to="/beta?intent=demo" className="btn btn-lg fm-on-dark">Book a demo</Link>
            <Link to="/beta?intent=waitlist" className="btn btn-lg fm-ghost-dark">Join the beta</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
